import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const AutocompleteRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const query = searchParams.get('q');
    console.log('Autocomplete query:', query);
    
    navigate('/', { replace: true });
  }, [searchParams, navigate]);
  
  return null;
};

export default AutocompleteRedirect;